var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { mq } from "core/styles/snippets";
import { Env, Id } from "core/utils";
export var Album = function (_a) {
    var url = _a.url, _b = _a.variant, variant = _b === void 0 ? "default" : _b, title = _a.title, className = _a.className;
    if (!Env.isClient)
        return null;
    return (React.createElement(Container, null,
        React.createElement(StyledIframe, { className: className, "data-component": Id.component.embed.spotify.album, src: "".concat(url, "?theme=0"), width: "100%", height: variant === "default" ? "380" : "80", frameBorder: "0", title: title })));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 0.5rem;\n"], ["\n  border-radius: 0.5rem;\n"])));
var StyledIframe = styled.iframe(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", " {\n    max-width: 34.125rem;\n  }\n"], ["\n  ", " {\n    max-width: 34.125rem;\n  }\n"])), mq.minWidth("800px"));
var templateObject_1, templateObject_2;
